import { rootElement } from '@shared/setup';
import SignIn from './SignIn/SignIn.vue';
import SignInRoot from './SignInRoot.vue';
import { createRouter, createWebHistory } from 'vue-router';
import BankID from './SignIn/BankID.vue';
import RedirectingBankID from './SignIn/RedirectingBankID.vue';

const initSignIn = async () => {
    const routes: any[] = [
        { path: '/', component: SignIn },
        { path: '/BankId/', component: RedirectingBankID },
        { path: '/BankId/Collect/', component: BankID },
    ];

    const router = createRouter({
        history: createWebHistory('/Account/SignIn/'),
        routes,
    });

    rootElement({
        name: 'SignInRoot', // pascal, camel & kebab-case are valid
        component: SignInRoot,
        vm: {},
        router: router,
        contextComponents: [{ name: 'WaitForLoading', template: '<div>Waiting...</div>' }],
    });
};

initSignIn();
